import { RootState } from '@/core/redux';
import { SettingsKeys } from '@/core/enums';

export const getSetting = <T = any>(state: RootState, key: SettingsKeys): T | undefined =>
  state.settings[key];
